import { HomeBoxType, HomeNewsLineType, HomeThreeType } from '../models';

export const homeBoxes: HomeBoxType[] = [
  {
    title1: '동반성장몰 소개',
    text: `도입기관 맞충형 몰구축이 가능한\n동반성장몰을 소개합니다!`,
    bg: '#5368F5',
    color: 'white',
    icon: 'assets/main1.png',
    idx: 1,
    mainUrl: '/business',
  },
  {
    title1: '동반성장몰 입점',
    title2: '희망 기업이라면?',
    text: `동반성장몰 입점을 원하시나요?\n동반성장몰과 함께 판로를 개척하세요!`,
    bg: '#323b4a',
    color: 'white',
    icon: 'assets/main4.png',
    idx: 2,
    mainUrl: '/entrance',
  },
  {
    title1: '동반성장몰 이용',
    title2: '임직원이라면',
    text: `동반성장몰 이용 중에\n궁금한 점이 있으신가요?`,
    bg: '#f6eeee',
    color: 'black',
    icon: 'assets/main3.png',
    idx: 3,
    mainUrl: '/customer',
  },
  {
    title1: '도입 희망',
    title2: '복지 담당자라면?',
    text: `동반성장몰 도입을 원하시나요?\n쉽고 빠르게 동반성장몰을 도입하세요!`,
    bg: '#e9e9e9',
    color: 'black',
    icon: 'assets/main2.png',
    idx: 4,
    mainUrl: '/introduction',
  },
];

export const homeThreeItem: HomeThreeType[] = [
  { en: 'Only For You', ko: '맞춤 상품' },
  { en: 'Everyday Sale', ko: '상시 할인' },
  { en: 'Grow With Us', ko: '상생 협력' },
];

export const homeNewsItem: HomeNewsLineType[] = [
  {
    key: '1',
    yyyymm: '26.03',
    dd: '06',
    title: "동반성장몰, 디지털 온누리상품권 결제수단으로 도입",
    link: 'https://www.yna.co.kr/view/AKR20260309063800030',
  },
  {
    key: '2',
    yyyymm: '25.12',
    dd: '04',
    title: '한유원 · 수자원공사, 협력中企에 동반성장몰 포인트 전달',
    link: 'https://www.news1.kr/articles/5093544',
  },
  {
    key: '3',
    yyyymm: '25.08',
    dd: '11',
    title: '울산항만공사, 중소기업 근로자 100명에 동반성장몰 포인트',
    link: 'https://www.news1.kr/articles/5093544',
  },
  {
    key: '4',
    yyyymm: '24.03',
    dd: '05',
    title: '中企유통센터 · 포스코, 동반성장몰 통해 중소기업 판로 확대',
    link: 'https://www.news1.kr/articles/5093544',
  },
];
